import script from "./EditPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditPassword.vue?vue&type=script&setup=true&lang=ts"

import "./EditPassword.vue?vue&type=style&index=0&id=023e88c1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-023e88c1"]])

export default __exports__